export interface Cabine {
  id: number;
  name: string;
  brand: string;
  category: string;
  description: string;
  features: string[];
  specs: { label: string; value: string }[];
  image: string;
  badge?: string;
}

export const cabines: Cabine[] = [
  {
    id: 1,
    name: 'Cabine Solo Pro',
    brand: 'AcoustiBox',
    category: 'Individual',
    description: 'Cabine acústica individual para foco total. Ideal para home office, ligações, videoconferências e trabalho concentrado. Redução de ruído de até 35dB.',
    features: ['Redução de 35dB', 'Ventilação silenciosa', 'Iluminação LED integrada', 'Tomadas e USB internos', 'Vidro duplo frontal', 'Montagem rápida'],
    specs: [
      { label: 'Dimensões', value: '120 × 120 × 220 cm' },
      { label: 'Capacidade', value: '1 pessoa' },
      { label: 'Isolamento', value: 'até 35dB' },
      { label: 'Ventilação', value: 'Sistema silencioso integrado' },
      { label: 'Peso', value: '180 kg' },
      { label: 'Montagem', value: 'Modular, sem obra' },
    ],
    image: '/media/ia/0198.webp',
    badge: 'Mais Vendido',
  },
  {
    id: 2,
    name: 'Cabine Duo Meet',
    brand: 'AcoustiBox',
    category: 'Dupla',
    description: 'Cabine para reuniões rápidas entre duas pessoas. Perfeita para feedbacks, entrevistas e conversas privadas em ambientes de open office.',
    features: ['Redução de 38dB', 'Mesa interna integrada', 'Iluminação LED regulável', 'Tomadas e USB internos', 'Vidro panorâmico', 'Assento ergonômico'],
    specs: [
      { label: 'Dimensões', value: '160 × 120 × 220 cm' },
      { label: 'Capacidade', value: '2 pessoas' },
      { label: 'Isolamento', value: 'até 38dB' },
      { label: 'Ventilação', value: 'Sistema silencioso integrado' },
      { label: 'Peso', value: '240 kg' },
      { label: 'Montagem', value: 'Modular, sem obra' },
    ],
    image: '/media/ia/0199.webp',
    badge: 'Novidade',
  },
  {
    id: 3,
    name: 'Cabine Team 4',
    brand: 'AcoustiBox',
    category: 'Reunião',
    description: 'Sala de reunião acústica para até 4 pessoas. Substitui salas de reunião tradicionais com instalação rápida e sem necessidade de obra.',
    features: ['Redução de 40dB', 'Mesa de reunião integrada', 'TV/monitor opcional', 'Ar-condicionado opcional', 'Vidro duplo panorâmico', 'Acesso por cartão'],
    specs: [
      { label: 'Dimensões', value: '240 × 200 × 230 cm' },
      { label: 'Capacidade', value: '4 pessoas' },
      { label: 'Isolamento', value: 'até 40dB' },
      { label: 'Ventilação', value: 'Ar-condicionado integrado' },
      { label: 'Peso', value: '420 kg' },
      { label: 'Montagem', value: 'Modular, sem obra' },
    ],
    image: '/media/ia/0200.webp',
  },
  {
    id: 4,
    name: 'Cabine Focus Slim',
    brand: 'SoundSpace',
    category: 'Individual',
    description: 'Design slim e compacto para espaços reduzidos. Ideal para ligações telefônicas e videoconferências rápidas. Ocupa apenas 0,9m².',
    features: ['Redução de 30dB', 'Design compacto', 'Iluminação LED', 'Carregador wireless', 'Ventilação passiva', 'Fácil relocação'],
    specs: [
      { label: 'Dimensões', value: '90 × 100 × 215 cm' },
      { label: 'Capacidade', value: '1 pessoa' },
      { label: 'Isolamento', value: 'até 30dB' },
      { label: 'Ventilação', value: 'Sistema passivo' },
      { label: 'Peso', value: '130 kg' },
      { label: 'Montagem', value: 'Modular, sem obra' },
    ],
    image: '/media/ia/0201.webp',
  },
  {
    id: 5,
    name: 'Cabine Podcast Studio',
    brand: 'SoundSpace',
    category: 'Estúdio',
    description: 'Cabine especializada para gravação de podcasts, vídeos e conteúdo digital. Tratamento acústico profissional com isolamento superior.',
    features: ['Redução de 45dB', 'Tratamento acústico interno', 'Suporte para microfone', 'Iluminação ring light', 'Tomadas e USB internos', 'Painel de controle'],
    specs: [
      { label: 'Dimensões', value: '140 × 130 × 220 cm' },
      { label: 'Capacidade', value: '1-2 pessoas' },
      { label: 'Isolamento', value: 'até 45dB' },
      { label: 'Ventilação', value: 'Sistema silencioso premium' },
      { label: 'Peso', value: '210 kg' },
      { label: 'Montagem', value: 'Modular, sem obra' },
    ],
    image: '/media/ia/0202.webp',
    badge: 'Premium',
  },
  {
    id: 6,
    name: 'Cabine Executive Lounge',
    brand: 'AcoustiBox',
    category: 'Lounge',
    description: 'Espaço privativo para descanso e trabalho focado. Design sofisticado com assento confortável, ideal para ambientes corporativos de alto padrão.',
    features: ['Redução de 32dB', 'Assento lounge premium', 'Mesa lateral integrada', 'Iluminação ambiente', 'Carregador wireless', 'Design exclusivo'],
    specs: [
      { label: 'Dimensões', value: '130 × 110 × 200 cm' },
      { label: 'Capacidade', value: '1 pessoa' },
      { label: 'Isolamento', value: 'até 32dB' },
      { label: 'Ventilação', value: 'Sistema silencioso' },
      { label: 'Peso', value: '160 kg' },
      { label: 'Montagem', value: 'Modular, sem obra' },
    ],
    image: '/media/ia/0203.webp',
  },
];
